module.exports = __webpack_public_path__ + "static/media/iheart.c712beef.svg";